import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-row-top",
  "use": "icon-row-top-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 8 4\" id=\"icon-row-top\"><g><path d=\"M4,0L8,4L0,4L4,0Z\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol